export class FigureData {
    public constructor(
        public readonly width: number,
        public readonly height: number
    ) { }
}